import type { IHttpRequest, IHttpResponse } from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { PostSessionPayloadDTO, PostSessionResponseDTO } from '../../dto';
import type { CreateSessionOptions } from './create-session.types';

export function createSession(
  baseUrl: string,
  payload: PostSessionPayloadDTO,
  options?: CreateSessionOptions<PostSessionPayloadDTO>,
): Promise<IHttpResponse<PostSessionResponseDTO>> {
  const call = options?.httpCall ?? fetchBasedCall;

  const request: IHttpRequest<PostSessionPayloadDTO> = {
    url: `${baseUrl}/session`,
    method: 'POST',
    body: payload,
    ...options?.requestOverride,
    schemas: {
      request: PostSessionPayloadDTO,
      response: PostSessionResponseDTO,
    },
  };

  return call(request);
}
